<template>
  <el-dialog
    title="管理员退出"
    :visible.sync="adminLogoutDialogVisible"
    width="430px"
    center
    :before-close="onClose"
  >
    <div class="adminLogoutContent">
      <el-form :model="adminLogoutForm" ref="adminLogoutForm"  @submit.native.prevent>
        <el-form-item prop="password">
          <el-input
            placeholder="管理员密码"
            @keyup.enter.native="onAdminLogout"
            v-model="adminLogoutForm.password"           
            type="password"
            autocomplete="off"          
          ><i @click="onAdminLogout" slot="suffix" style="cursor:pointer" class="el-input__icon fa fa-arrow-right"></i></el-input>
          <el-input v-show="false"></el-input>
          <el-row class="el-form-control errorMessageContainer">
            <el-col :span="24" v-if="showError">
              <el-alert :closable="false" v-bind:title="errorMessage" type="error" show-icon></el-alert>
            </el-col>
          </el-row>        
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer"></span>
  </el-dialog>
</template>

<style lang="scss" scoped>
.adminLogoutContent {
  margin: 0 50px;
}
</style>

<script>
export default {
  data() {
    return {
      adminLogoutForm: {
        password: ""
      }
    };
  },
  props: {
    adminLogoutDialogVisible: false,
    showError: false,
    errorMessage: ""
  },
  updated() {},
  created() {},
  methods: {
    onAdminLogout() {
      this.$emit("onAdminLogout", this.adminLogoutForm.password);
    },

    onClose() {
      this.$emit("onCloseDialog", false);
    },   
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/adminLogout.vue